import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    shoppableVideoContainer: {
        position: 'relative',
        width: '100%',
        paddingTop: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '50%',
            paddingTop: '50%',
        },
    },
    hotspotContainer: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        right: 0,
        left: 0,
        top: 0,
    },
    hotspotLink: {
        '& button': Object.assign({ padding: '14px 31px', color: colors.background.WHITE }, theme.typography.medium_bold),
    },
    hotspot: {
        color: colors.primary.gold4,
    },
    tooltip: {
        borderRadius: '12px',
        padding: `${spacing.xs} ${spacing.small}`,
        '& .MuiTooltip-arrow': {
            fontSize: '2rem',
        },
    },
    popper: {
        zIndex: 1,
    },
    desktopImage: {
        display: 'none',
        '& > .displayDesktopImage': {
            display: 'block',
        },
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    mobileImage: {
        display: 'block',
        '& button': {
            paddingTop: '100%',
        },
        [theme.breakpoints.up('sm')]: {
            display: 'none',
            paddingTop: 0,
        },
    },
    displayDesktopImage: {
        display: 'block',
    },
}));
export default useStyles;
